/* eslint-disable */
import {getCategoryList} from '@/api/Kilimall/seller'



  const  state = {
    attr_template_data:{},
    uploadPath:'',
    category_data:[],
    shipping_info:{}, //物流信息
    product_service_rule:[],//售后服务
    product_properties:[],//商品属性
    product_spec_map:[],//商品规格
    goodsInfoValue:{},//基本信息
    product_state:'',//上下架
    skus_list:[] ,//sku列表
    change_spec:-1,
    media_list:[],//商品媒体数据
    product_mobile_body:[],//商品详情
    tebale_column_data:[],//table
    product_logistics_type:'',//仓库
    shop_Category:[],//店铺类目
    product_type:[], //品类类型
    s3_image_path:'',//图片上传路径
    product_tax: '' //税率
};
const mutations = {
  ADD_ATTR_TEMP:(state:any,data:any) => {
    state.attr_template_data = data
  },
  SET_CATEGORY_LIST:(state:any,data:any) => {
    state.category_data = data   
  },
  ADD_LOGISTICS_DATA:(state:any,data:any) =>{
    state.shipping_info = data  
  },
  SET_PRODUCT_SERVER_ROLE:(state:any,data:any) =>{
    state.product_service_rule = data  
  },
  SET_PRODICT_PROPERTIES:(state:any,data:any) =>{
    state.product_properties = data  
  },
  SET_PRODUCT_SPEC_MAP:(state:any,data:any) =>{
    state.product_spec_map = data  
  },
  SET_GOODS_INFO_VALUE:(state:any,data:any) =>{
    state.goodsInfoValue = data  
  },
  SET_PRODUCT_STATE:(state:any,data:any) =>{
    state.product_state = data  
  },
  SET_PRODUCT_TAX:(state:any,data:any) =>{
    state.product_tax = data  
  },
  SET_SKU_LIST:(state:any,data:any) =>{
    state.skus_list = data  
  },
  SET_MEDIA:(state:any,data:any) =>{
    state.media_list = data  
  },
  SET_PRODUCT_MOBILE_BODY:(state:any,data:any) =>{
    state.product_mobile_body = data  
  },
  SET_TABLE_COLUMN_DATA:(state:any,data:any) =>{
    state.tebale_column_data = data  
  }, 
  SET_SHOP_CATEGORY:(state:any,data:any) =>{
    state.shop_Category = data  
  },
  SET_PRODECT_TYPE:(state:any,data:any) =>{
    state.product_type = data  
  },

  
  
};
const  actions = {
  add_attr_fn: ({commit}:any,data:any) => {
    commit('ADD_ATTR_TEMP',data)
  },
  get_category_list: async ({commit}:any) => {
    let res:any = await getCategoryList()
    if(res.code == 200) {
    commit('SET_CATEGORY_LIST',res.data)
    }
  },
  add_logistics_data: ({commit}:any,data:any) => {
    commit('ADD_LOGISTICS_DATA',data)
  },
  set_product_service_rule: ({commit}:any,data:any) => {
    commit('SET_PRODUCT_SERVER_ROLE',data)
  },
   set_product_properties: ({commit}:any,data:any) => {
   commit('SET_PRODICT_PROPERTIES',data)
  },
  set_product_spec_map: ({commit}:any,data:any) => {
    commit('SET_PRODUCT_SPEC_MAP',data)
   },
   set_goodsInfoValue: ({commit}:any,data:any) => {
    commit('SET_GOODS_INFO_VALUE',data)
   },
   set_product_state: ({commit}:any,data:any) => {
    commit('SET_PRODUCT_STATE',data)
   },
   set_product_tax: ({commit}:any,data:any) => {
    commit('SET_PRODUCT_TAX',data)
   },
   set_sku_list: ({commit}:any,data:any) => {
    commit('SET_SKU_LIST',data)
   },
   set_media:({commit}:any,data:any) => {
    commit('SET_MEDIA',data)
   },
   set_product_mobile_body:({commit}:any,data:any) => {
    commit('SET_PRODUCT_MOBILE_BODY',data)
   },
   set_tebale_column_data:({commit}:any,data:any) => {
    commit('SET_TABLE_COLUMN_DATA',data)
   },
   set_shop_Category:({commit}:any,data:any) => {
    commit('SET_SHOP_CATEGORY',data)
   },
   set_product_type:({commit}:any,data:any) => {
    commit('SET_PRODECT_TYPE',data)
   },

  
}


export default {
state,
mutations,
actions
}